import React from 'react';
import { Layer, Line } from 'react-konva';

import { useMediaStudio } from '../context/MediaStudioContext';

function GuidesLayer({ guides, docHeight, docWidth, zoom }) {
  const { themeColors } = useMediaStudio();

  if (!guides?.length) {
    return null;
  }

  return (
    <Layer listening={false}>
      {guides.map((guide) =>
        guide.orientation === 'v' ? (
          <Line
            key={`v-${guide.position}`}
            points={[guide.position, 0, guide.position, docHeight]}
            stroke={themeColors.accent}
            strokeWidth={1 / zoom}
            dash={[4 / zoom, 4 / zoom]}
          />
        ) : (
          <Line
            key={`h-${guide.position}`}
            points={[0, guide.position, docWidth, guide.position]}
            stroke={themeColors.accent}
            strokeWidth={1 / zoom}
            dash={[4 / zoom, 4 / zoom]}
          />
        ),
      )}
    </Layer>
  );
}

export default GuidesLayer;
